import Glide from '@glidejs/glide';

(function ($) {
	$(document).ready(function () {
		let municipalityExperienciesSlider = document.querySelector('.municipality__experiences__glide.mobile');

		if (municipalityExperienciesSlider) {
			let glideExperiencia = new Glide('.municipality__experiences__glide.mobile', {
				type: 'carousel',
				perView: 1.125,
				gap: '15px'
			});
			glideExperiencia.mount();
		}
	});
})(jQuery);
